import styled from 'styled-components'

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #303030;
`

export const Button = styled.button<{ variant?: 'primary' | 'outline' }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  
  ${props => props.variant === 'primary' ? `
    background-color: #0090D3;
    color: #FFFFFF;
    border: none;
  ` : `
    background-color: #FFFFFF;
    color: #0090D3;
    border: 1px solid #0090D3;
  `}
`

export const Card = styled.div`
  background-color: #FFFFFF;
  border-radius: 16px;
  border-left: 1px solid #f4f4f4;
  padding: 20px;
  width: 100%;
  margin-bottom: 1rem;
`

export const FormGrid = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 20px;
`

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
`

export const Select = styled.select`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: none;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
`

export const InfoLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
`

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: #EBEBEB;
  margin: 20px 0;
`

export const CollapsibleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const Summary = styled.div`
  display: flex;
  gap: 32px;
`

export const SummaryItem = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`

export const SummaryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  white-space: nowrap;
`

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  flex: 1;
`

export const AddProductContainer = styled.div`
  margin-top: 16px;
`

export const AddButton = styled.div`
    width: 13.9vw;
    height: 5.9vh;
    border-radius: 20px;
    border: 1px solid #0090D3;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin: 20px auto;
`

export const AddButtonImg = styled.img`
    width: 0.8vw;
    height: 1.7vh;
    color: #0090D3;
`

export const AddButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 1rem;
    color: #0090D3
`

export const BreadCrumble = styled.div`
    display: flex;
    gap: 8px;
    margin-bottom: 1rem;
`
export const FirstText = styled.p`
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    size: 1rem;
    color: #0090D3;
`

export const SecondText = styled.p`
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    size: 1rem;
    color: #696969
`

export const MoreInformation = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 23vw;
  height: 29vh;
  padding: 12px;
  border-radius: 0 16px 16px 16px;
  border: 1px solid #EBEBEB;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 10;
`

export const InfoName = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #696969;
  display: flex;
  gap: 16px;
  height: 21px;
`

export const InfoValue = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #303030;
`

export const ProductShort = styled.div`
    display: flex;
    align-items: center;
`

export const ProductDiv = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 0.5rem;
`


export const ActionsDiv = styled.div`
    display: flex;
    gap: 32px;
    padding-left: 2rem;
`

export const InputText = styled.input`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: none;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
`

export const ShortLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 20px;
  background-color: #ebebeb;
  padding: 8px 12px;
  width: 100%;
  max-width: 390px;
`

export const FileUploadLabel = styled.label`
  background-color: #fff;
  border-radius: 4px;
  padding: 3px 6px;
  cursor: pointer;
  margin-right: 8px;
  white-space: nowrap;
  font-size: 0.8rem;
`

export const FileNameText = styled.span`
  color: #666;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`